import PortalVue from 'portal-vue';
import Vue from 'vue';
// eslint-disable-next-line import/no-named-as-default
import VueCurrencyInput, { CurrencyInputOptions, } from 'vue-currency-input';
import VueMeta from 'vue-meta';
import { SelfServeApiPlugin, } from '~/api/self-serve-api';
import type { ConfigValueAccessor, } from '~/utils/self-serve/global-config';
import { loadGlobalConfig, } from '~/utils/self-serve/global-config';
import App from './app.vue';
import { Router, } from './router';
import { Store, } from './store';

import '~/assets/scss/self-serve.scss';
import '~/assets/scss/fontawesome.scss';

Vue.config.productionTip = false;
Vue.use(VueMeta);

const currencyPluginOptions: CurrencyInputOptions = {
	allowNegative: false,
	autoDecimalMode: false,
	currency: undefined,
	distractionFree: {
		hideCurrencySymbol: true,
	},
};

Vue.use(PortalVue);
Vue.use(VueCurrencyInput, {
	// eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
	globalOptions: currencyPluginOptions,
});

const router = Router;

export function PayBill(mountPoint: string | HTMLElement, configValueAccessor: ConfigValueAccessor) {
	const globalConfig = loadGlobalConfig(configValueAccessor);
	Vue.use(SelfServeApiPlugin, {
		baseUrl: globalConfig.SelfServeApiAddress || '',
	});

	Store.commit.hydrateGlobalConfig(globalConfig);

	new Vue({
		router,
		render(h) {
			return h(App);
		},
		store: Store.original,
	}).$mount(mountPoint);
}
